import { Extension } from '@tiptap/core'
import Suggestion from '@tiptap/suggestion'

const SlashCommands = Extension.create({
  name: 'slashcommands',
  priority: 1000,
  addOptions() {
    return {
      suggestion: {
        char: '/',
        allowSpaces: false,
        command: ({ editor, range, props }) => {
          props.command({ editor, range })
        },
      },
    }
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
        decorationClass: "slash-suggestion"
      }),
    ]
  },
})

export default SlashCommands;